'use client';

// needed for react-tooltip
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip as LibTooltip, ITooltip } from 'react-tooltip';

export default function Tooltip(props: ITooltip) {
  return <LibTooltip {...props} />;
}
